import { CardModel, CardShift, PileCardModel } from "../../interface/game";
import { PileAnnotationPolicy } from "./pile-annotation-policy";

export function pileOpenCardsPolicy(shift: CardShift = CardShift.OPEN): PileAnnotationPolicy {
    return (pile: PileCardModel[], cards: {[key: string]: CardModel}): PileCardModel[] => {
        for (const card of pile) {
            cards[card.id] = {...cards[card.id], shift: shift};
        }
        return pile;
    }
}